var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-welcome-screen",
    },
    [
      _c("div", {
        staticClass: "cw-welcome-screen-keyvisual",
      }),
      _vm._v(" "),
      _c("header", [
        _vm._v(
          "\n        " +
            _vm._s(_vm.$gettext("Willkommen bei Courseware")) +
            "\n    "
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "cw-welcome-screen-actions",
        },
        [
          _c(
            "a",
            {
              staticClass: "button",
              attrs: {
                href: "https://hilfe.studip.de/help/5.0/de/Basis.Courseware",
                target: "_blank",
              },
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$gettext("Mehr über Courseware erfahren")) +
                  "\n        "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "button",
              attrs: {
                title: _vm.$gettext(
                  "Fügt einen Standard-Abschnitt mit einem Text-Block hinzu"
                ),
              },
              on: {
                click: _vm.addDefault,
              },
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$gettext("Ersten Inhalt erstellen")) +
                  "\n        "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "button",
              on: {
                click: _vm.addContainer,
              },
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$gettext("Einen Abschnitt auswählen")) +
                  "\n        "
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }